import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import "../../../constants/index.js";
import useDateAvailCheck from "../../../hooks/useDateAvailCheck.js";
import { detectFbIab, detectLineIab, detectIosDevice } from "../../../utils/browser.js";
import moment from "moment";
import { useState, useRef, useEffect, useCallback } from "react";
import Dialog from "../../utils/Dialog/Dialog.js";
const THREE_DAYS = 24 * 60 * 60 * 3;
const PWA_REMINDER_KEY = "pwa-reminder";
const PwaInstaller = ({
  children,
  reminderPeriod = THREE_DAYS,
  reminderKey = PWA_REMINDER_KEY,
  hideOnPWA = true,
  onInstalled,
  onDismissed,
  withInstructions = true,
  instructionOptions,
  onInstallable,
  ignoreDismissed = false,
  ignoreSelfCheck = false,
  onBeforeInstallPrompt,
  externalInstallerPrompt
}) => {
  const [installable, setInstallable] = useState(false);
  const deferredPrompt = useRef();
  const [openExtBrowserInstruction, setOpenExtBrowserInstruction] = useState(false);
  const [openShareAddHomeScreenInstruction, setOpenShareAddHomeScreenInstruction] = useState(false);
  const { dueAt: nextDisplayAt, updateDueAt: setNextDisplayAt } = useDateAvailCheck(reminderKey);
  useEffect(() => {
    onInstallable == null ? void 0 : onInstallable(installable);
  }, [installable, onInstallable]);
  useEffect(() => {
    if (ignoreSelfCheck) {
      setInstallable(true);
      return;
    }
    if (hideOnPWA) {
      const displayMode = sessionStorage.getItem("display-mode");
      if (displayMode === "standalone") {
        return;
      }
    }
    const beforeInstallPromptHandler = (e) => {
      e.preventDefault();
      deferredPrompt.current = e;
      onBeforeInstallPrompt == null ? void 0 : onBeforeInstallPrompt(e);
      const isDisplaying = nextDisplayAt ? moment().isAfter(nextDisplayAt) : true;
      if (!isDisplaying && !ignoreDismissed) {
        return;
      }
      setInstallable(true);
    };
    window.addEventListener("beforeinstallprompt", beforeInstallPromptHandler);
    return () => {
      window.removeEventListener("beforeinstallprompt", beforeInstallPromptHandler);
    };
  }, [hideOnPWA, nextDisplayAt, onInstalled, ignoreDismissed, onBeforeInstallPrompt, ignoreSelfCheck]);
  useEffect(() => {
    const appInstalledHandler = () => {
      onInstalled == null ? void 0 : onInstalled();
    };
    window.addEventListener("appinstalled", appInstalledHandler);
    return () => window.removeEventListener("appinstalled", appInstalledHandler);
  }, [ignoreSelfCheck, onInstalled]);
  const doInstall = useCallback(() => {
    const prompt = externalInstallerPrompt ?? deferredPrompt.current;
    setInstallable(false);
    prompt == null ? void 0 : prompt.prompt();
    prompt == null ? void 0 : prompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        onInstalled == null ? void 0 : onInstalled();
      } else {
        setInstallable(true);
        onDismissed == null ? void 0 : onDismissed();
      }
    });
  }, [onDismissed, onInstalled, externalInstallerPrompt]);
  const handleClose = useCallback(() => {
    setNextDisplayAt(moment().add(reminderPeriod, "seconds"));
    setInstallable(false);
  }, [reminderPeriod, setNextDisplayAt]);
  const handleInstall = useCallback(() => {
    if (detectFbIab() || detectLineIab()) {
      setOpenExtBrowserInstruction(true);
      return;
    }
    if (detectIosDevice()) {
      setOpenShareAddHomeScreenInstruction(true);
      return;
    }
    doInstall();
  }, [doInstall]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    installable && children(handleInstall, handleClose),
    /* @__PURE__ */ jsx(
      Dialog,
      {
        open: openExtBrowserInstruction,
        onClose: () => setOpenExtBrowserInstruction(false),
        title: instructionOptions == null ? void 0 : instructionOptions.openExtBrowser.title,
        classes: {
          "title&": "!mb-4"
        },
        children: /* @__PURE__ */ jsx(
          "video",
          {
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true,
            className: "rounded-xl",
            children: /* @__PURE__ */ jsx(
              "source",
              {
                src: instructionOptions == null ? void 0 : instructionOptions.openExtBrowser.videoSrc,
                type: "video/mp4"
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      Dialog,
      {
        open: openShareAddHomeScreenInstruction,
        onClose: () => setOpenShareAddHomeScreenInstruction(false),
        title: instructionOptions == null ? void 0 : instructionOptions.openShareAddHomeScreen.title,
        classes: {
          "title&": "!mb-4"
        },
        children: /* @__PURE__ */ jsx(
          "video",
          {
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true,
            className: "rounded-xl",
            children: /* @__PURE__ */ jsx(
              "source",
              {
                src: instructionOptions == null ? void 0 : instructionOptions.openShareAddHomeScreen.videoSrc,
                type: "video/mp4"
              }
            )
          }
        )
      }
    )
  ] });
};
const PwaInstaller$1 = PwaInstaller;
export {
  PwaInstaller$1 as default
};
